import {createReducer, on} from '@ngrx/store';
import {
  GetPropertyUploadsResponseModel,
  PropertyUploadsModel
} from '../../../shared/models/uploads/property-uploads.models';
import {DefaultStoreState} from '../../models/app-state.model';
import { PropertyUploadActions } from '../../actions/property/property-uploads.actions';

export const propertyUploadsKey = 'propertyUploads';

export interface State extends DefaultStoreState {
  details: PropertyUploadsModel[];
}

const initialState: State = {
  details: null,
  isLoading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(
    PropertyUploadActions.loadPropertyUploads,
    (state: State) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    PropertyUploadActions.loadPropertyUploadsSuccess,
    (state: State, res: GetPropertyUploadsResponseModel) => ({
      ...state,
      details: res.data,
      isLoading: false
    })
  ),
  on(
    PropertyUploadActions.loadPropertyUploadsFailure,
    (state: State, error) => ({
      ...state,
      error
    })
  ),
);
